module.exports = __webpack_public_path__ + "static/img/jiat-innovation.5977c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jiat-innovation.jpg
// module id = Po16
// module chunks = 0